import { PointerSensor, useSensor, useSensors } from '@dnd-kit/core';

export function useDndSensors() {
  return useSensors(
    useSensor(PointerSensor, {
      activationConstraint: {
        distance: 8, // Require 8px movement before drag starts
      },
    }),
  );
}
